import Repo from './Repo.js'

export default class UserCheckoutFormStatusRepository extends Repo {
  constructor () {
    super('user-checkout-form-statuses')
  }

  all (q, include) {
    return super.all(q, {include: include})
  }

  store (data) {
    return super.store(data)
  }

  update (id, data) {
    return super.update(id, data)
  }

  get (id, include) {
    return super.get(id, {include: include})
  }

  delete (id) {
    return super.delete(id)
  }

  paginate (q, include) {
    return super.paginate(q, include)
  }
}
